import { handleActions } from "redux-actions"
import produce from "immer"
import lodash from "lodash"

import { RECEIVE, REQUEST } from "./constants"

const initialState = {
  isLoading: false,
  result: []
}

const handleRequest = produce(draft => {
  draft.isLoading = true
  draft.result = []
  // console.log("handleRequest")
})

const handleReceive = produce((draft, { payload: { result, error } }) => {
  draft.isLoading = false
  draft.result = result
  // console.log("handleReceive voice", result, error)
})

export default handleActions(
  {
    [REQUEST]: handleRequest,
    [RECEIVE]: handleReceive
  },
  initialState
)
